<template>
    <div class="card h-100 rounded-0 border-0" :class="animation">
        <div class="card-body text-center h-100 p-0">
            <div class="row">
                <BackButton @click.native="handleBackToStep()" />
            </div>
            <div class="row">
                <div class="form-wrap-step">
                    <div>
                        <h5 class="title__normal">ゴミの種類を選択してください。</h5>
                    </div>
                </div>
            </div>
            <div class="form-wrap-step">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <form @submit.prevent="onSubmit()">
                            <div class="form-group row mb-1 mb-sm-label">
                                <div class="col-3 lb-below-adv">
                                    <label class="col-form-label label1">粗大ゴミ1 <span class="text-danger">*</span></label>
                                </div>
                                <div class="col-9 in-below-adv">
                                    <input 
                                        type="text" 
                                        class="form-control rounded-0" 
                                        name="typeOfOverSizeGarbage1"
                                        v-model="typeOfOverSizeGarbage1"
                                        @input="onChange($event)"
                                    />
                                    <p class="text-left mb-0">
                                        <span 
                                            v-if="!$v.typeOfOverSizeGarbage1.required && $v.typeOfOverSizeGarbage1.$dirty" 
                                            class="help-block error-help-block"
                                        >入力必須です
                                        </span>
                                        <span 
                                            v-if="(!$v.typeOfOverSizeGarbage1.maxLength) && $v.typeOfOverSizeGarbage1.$dirty" 
                                            class="help-block error-help-block"
                                        >50文字以下で入力してください
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="form-group row mb-1 mb-sm-label">
                                <div class="col-3 lb-below-adv">
                                    <label class="col-form-label label1">粗大ゴミ2</label>
                                </div>
                                <div class="col-9 in-below-adv">
                                    <input 
                                        type="text" 
                                        class="form-control rounded-0" 
                                        name="typeOfOverSizeGarbage2"
                                        v-model="typeOfOverSizeGarbage2"
                                        @input="onChange($event)"
                                    />
                                    <p class="text-left mb-0">
                                        <span 
                                            v-if="(!$v.typeOfOverSizeGarbage2.maxLength) && $v.typeOfOverSizeGarbage2.$dirty" 
                                            class="help-block error-help-block"
                                        >50文字以下で入力してください
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="form-group row mb-1 mb-sm-label">
                                <div class="col-3 lb-below-adv">
                                    <label class="col-form-label label1">粗大ゴミ3</label>
                                </div>
                                <div class="col-9 in-below-adv">
                                    <input 
                                        type="text" 
                                        class="form-control rounded-0" 
                                        name="typeOfOverSizeGarbage3"
                                        v-model="typeOfOverSizeGarbage3"
                                        @input="onChange($event)"
                                    />
                                    <p class="text-left mb-0">
                                        <span 
                                            v-if="(!$v.typeOfOverSizeGarbage3.maxLength) && $v.typeOfOverSizeGarbage3.$dirty" 
                                            class="help-block error-help-block"
                                        >50文字以下で入力してください
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="form-group row mb-2">
                                <div class="col-3 lb-below-adv">
                                    <label class="col-form-label label1">特記事項</label>
                                </div>
                                <div class="col-9 in-below-adv">
                                    <input
                                        class="form-control rounded-0"
                                        name="typeOfSizeGarbageOther"
                                        v-model="typeOfSizeGarbageOther"
                                        @input="onChange($event)"
                                    />
                                    <p class="text-left mb-0">
                                        <span 
                                            v-if="(!$v.typeOfSizeGarbageOther.maxLength) && $v.typeOfSizeGarbageOther.$dirty" 
                                            class="help-block error-help-block"
                                        >200文字以下で入力してください
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="form-group row below-adv-btn mb-0">
                                <div class="col-md-12 text-center">
                                    <button type="submit" id="btnOversizeGarbage" class="btn btn-yellow-dark px-5 d-inline-block btn-lg rounded-1">
                                        <span class="text">次へ</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { required, maxLength } from 'vuelidate/lib/validators';
    import BackButton from '../BackButton.vue';

    export default {
    name: 'TypeOfGarbage',
    props: {
        animation: {
            default: ''
        },
        formValue: {
            typeOfOverSizeGarbage1: {
                default: ''
            },
            typeOfOverSizeGarbage2: {
                default: ''
            },
            typeOfOverSizeGarbage3: {
                default: ''
            },
            typeOfSizeGarbageOther: {
                default: ''
            },
        },
        allData: {
            default: ''
        }
    },  
    data() {
        return {
            typeOfOverSizeGarbage1: this.formValue.typeOfOverSizeGarbage1,
            typeOfOverSizeGarbage2: this.formValue.typeOfOverSizeGarbage2,
            typeOfOverSizeGarbage3: this.formValue.typeOfOverSizeGarbage3,
            typeOfSizeGarbageOther: this.formValue.typeOfSizeGarbageOther,
            NO_COLLECTED: 0,
        };
    },
    validations: {
        typeOfOverSizeGarbage1: {
            required,
            maxLength: maxLength(50),
        },
        typeOfOverSizeGarbage2: {
            maxLength: maxLength(50),
        },
        typeOfOverSizeGarbage3: {
            maxLength: maxLength(50),
        },
        typeOfSizeGarbageOther: {
            maxLength: maxLength(200),
        }
    },
    methods: {
        onChange(e) {
            let payload = {
                label: 'trashOversized',
                data: {
                    ...this.formValue,
                    [e.target.name]: e.target.value
                }
            };
            this.$emit('onChangeFormValue', payload);
        },
        validate() {
            this.$v.$touch();
        },
        onSubmit() {
            this.validate();
            if (!this.$v.$invalid) {
                // const currentStep = 3;
                // const followStep = 1;
                // this.$emit("handleChangeStep", currentStep, followStep);
                this.postData();
            }
        },
        handleBackToStep: function () {
            const currentStep = 2;
            const followStep = 0;
            this.$emit("handleChangeStep", currentStep, followStep);
        },
        async postData() {
            this.data = {
                ...this.allData,
                is_collect: this.NO_COLLECTED,
            };

            let res = await axios.post(`/api/register/register-info/`, this.data);
            if (res.data.success) {
                window.location.href = '/order/order-oversized-step-company';
            } else {
                alert('Failed to continue');
            }
        },
    },
    components: { 
        BackButton 
    }
}
</script>